const maskDay = '([0-2][0-9]|(3)[0-1])'
const maskMonth = '(((0)[0-9])|((1)[0-2]))'
const maskYearLong = '([0-9][0-9][0-9][0-9])'
const maskYearShort = '([0-9][0-9])'

export const parseDate = (input: string) => {
  // check YYYY-MM-DD
  if (input.match(`${maskYearLong}(-)${maskMonth}(-)${maskDay}`)) {
    const dateParts = input.split('-')
    return {year: +dateParts[0], month: +dateParts[1], day: +dateParts[2]}
  }

  // check MM/DD/YYYY
  if (input.match(`${maskMonth}(/)${maskDay}(/)${maskYearLong}`)) {
    const dateParts = input.split('/')
    return {year: +dateParts[2], month: +dateParts[0], day: +dateParts[1]}
  }

  // check DD.MM.YYYY
  if (input.match(`${maskDay}([.])${maskMonth}([.])${maskYearLong}`)) {
    const dateParts = input.split('.')
    return {year: +dateParts[2], month: +dateParts[1], day: +dateParts[0]}
  }

  // check DD.MM.YY
  if (input.match(`${maskDay}([.])${maskMonth}([.])${maskYearShort}`)) {
    const dateParts = input.split('.')
    const shortYear = +dateParts[2]
    const year = shortYear > 50 ? 1900 + shortYear : 2000 + shortYear
    return {year, month: +dateParts[1], day: +dateParts[0]}
  }

  return null
}
